<template>
  <div class="tw-border-y tw-border-grey-mid tw-grid tw-grid-cols-12 tw-px-8 tw-divide-x tw-divide-grey-mid -tw-mx-8">
    <slot />
  </div>
</template>
